export default __webpack_public_path__ + "images/equipamentos-ico.svg";